import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "annabells_admin_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => localStorage.setItem(KEY, t);
export const clearToken = () => localStorage.removeItem(KEY);

const authed = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password }).then((r) => r.data.token);
export const adminMe = () => axios.get(`${API}/admin/me`, authed());
export const fetchOrders = () => axios.get(`${API}/order-requests`, authed()).then((r) => r.data);
export const updateOrder = (id, changes) => axios.patch(`${API}/order-requests/${id}`, changes, authed()).then((r) => r.data);
export const fetchReviews = () => axios.get(`${API}/admin/reviews`, authed()).then((r) => r.data);
export const updateReview = (id, status) => axios.patch(`${API}/admin/reviews/${id}`, { status }, authed()).then((r) => r.data);
export const deleteReview = (id) => axios.delete(`${API}/admin/reviews/${id}`, authed()).then((r) => r.data);

export function apiError(e) {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    return e?.message || "Something went wrong.";
}

export const STATUSES = [
    { value: "new", label: "New", className: "bg-[#FDF0F4] text-[#C95B7D] border-[#F2E1E6]" },
    { value: "contacted", label: "Contacted", className: "bg-[#FAF0D7] text-[#8a6a10] border-[#D4AF37]/40" },
    { value: "booked", label: "Booked", className: "bg-[#E9F3EA] text-[#2f6b3a] border-[#bfe0c5]" },
    { value: "done", label: "Done", className: "bg-[#F1ECE7] text-[#6B4A3E] border-[#e2d8d0]" },
];
